import React, { useState } from "react";

const AuthContext = React.createContext({
  token: "",
  userInfos: {},
  isLoggedIn: false,
  login: (token, userInfos) => {},
  logout: () => {},
});

export const AuthContextProvider = (props) => {
  const [token, setToken] = useState(null);
  const [userInfos, setUserInfos] = useState({});
  const [userIsLoggedIn, setUserIsLoggedIn] = useState(false);

  const loginHandler = (token, userInfos) => {
    setToken(token);
    setUserInfos(userInfos);
    setUserIsLoggedIn(true);
  };

  const logoutHandler = () => {
    setToken(null);
    setUserInfos({});
  };

  const contextValue = {
    token: token,
    userInfos: userInfos,
    isLoggedIn: userIsLoggedIn,
    login: loginHandler,
    logout: logoutHandler,
  };

  return (
    <AuthContext.Provider value={contextValue}>
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
